import React, { useRef, useState, useContext } from "react"
import Button from "../atoms/button.atom"
import Input from "../atoms/input.atom"
import { CogIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"
import TextArea from "../atoms/textarea.atom"
import { toast } from "react-toastify"
import { flatten, parseStringTemplate, TemplateVariables, validateYup } from "./template.utils"
import * as yup from "yup"
import { AuthContext } from "../../context/auth.context"
import { Header } from "../common/header"
import Select from "../atoms/select.atom"
import { getCookie } from "../../helper/auth"
// const templateVariablesFlatten = flatten(TemplateVariables);

export const WhatsAppUpdateTemplate = ({ hubId, onUpdateWhatsAppTemplate }) => {
	const { auth } = useContext(AuthContext)
	const selectedData = auth.passData

	const [loading, setLoading] = useState(false)

	const templateTextRef = useRef(null)
	const [error, setError] = useState({})
	const [templateVariablesFlat, setTemplateVariablesFlat] = useState([])
	const [templateVariablesFlatFiltered, setTemplateVariablesFlatFiltered] = React.useState([])
	const optionsType = [
		{ value: "contact", label: "Contact" },
		{ value: "deals", label: "Deals" },
		{ value: "companies", label: "Companies" },
		{ value: "tickets", label: "Ticket" }
	]
	const [optionTypeData, setOptionTypeData] = useState({
		statusLabel: "Contact",
		status: "contact"
	})
	const [formObj, setFormData] = useState({
		text: "",
		name: "",
		templatename: "",
		status: "",
		module: "",
		mediatype: "",
		mediaURL: ""
	})

	const [searchVariable, setSearchVariable] = useState()

	const setFormObj = (obj) => {
		setFormData({ ...formObj, ...obj })
	}

	const getTemplatePropertiesCallBack = React.useCallback((value) => {
		getTemplateProperties(value)
	}, [])

	const getTemplateProperties = (value) => {
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.get(EndpointConfig.VFTemplateProperties, {
				headers: { Authorization: `Bearer ${token}` },
				params: {
					propertyType: value === "" ? optionTypeData.status : value
				}
			})
			const flatArray = []
			setSearchVariable("")
			setTemplateVariablesFlat([])
			res.data.map((item, index) => {
				if (optionTypeData.status === "contact") {
					flatArray.push({
						contact: item.name
					})
				} else if (optionTypeData.status === "deals") {
					flatArray.push({
						deals: item.name
					})
				} else if (optionTypeData.status === "companies") {
					flatArray.push({
						companies: item.name
					})
				} else if (optionTypeData.status === "tickets") {
					flatArray.push({
						tickets: item.name
					})
				}
			})
			const flatData = flatten(flatArray)
			setTemplateVariablesFlat(flatData)
			setTemplateVariablesFlatFiltered(flatData)
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	React.useEffect(() => {
		getTemplateProperties("Contact")
		console.log("selectedData", selectedData)
		setFormData({
			text: selectedData.templatetext,
			name: selectedData.name,
			templatename: selectedData.templatename,
			status: selectedData.status,
			module: selectedData.module,
			mediatype: selectedData.mediatype,
			mediaURL: selectedData.mediaURL
		})
	}, [])

	const updateTemplate = () => {
		let schema = yup.object().shape({
			name: yup.string().trim().required("Required"),
			templatename: yup.string().trim().required("Required"),
			text: yup.string().trim().required("Required"),
			status: yup.string().trim().required("Required"),
			module: yup.string().trim().required("Required")
		})
		const reqObj = {
			...formObj
		}

		const text = reqObj.text
		if (reqObj.module === "Contact") {
			if (
				text.includes("{{deals.") ||
				text.includes("{{companies.") ||
				text.includes("{{tickets.")
			) {
				toast.error("Please use contact variables only")
				return
			}
		} else if (reqObj.module === "Deals") {
			if (text.includes("{{companies.") || text.includes("{{tickets.")) {
				toast.error("Please use deal variables only")
				return
			}
		} else if (reqObj.module === "Companies") {
			if (text.includes("{{deals.") || text.includes("{{tickets.")) {
				toast.error("Please use company variables only")
				return
			}
		} else if (reqObj.module === "Tickets") {
			if (text.includes("{{deals.") || text.includes("{{companies.")) {
				toast.error("Please use ticket variables only")
				return
			}
		}

		validateYup(schema, reqObj)
			.then(() => {
				setError({})
				setLoading(true)
				;(async () => {
					const resDelete = await axiosInstance.delete(EndpointConfig.VFSMSTemplates, {
						headers: {
							"hub-id": hubId
						},
						data: {
							templateId: selectedData._id
						}
					})
					await axiosInstance.put(
						EndpointConfig.VFWhatsAppTemplates + "/" + selectedData._id,
						{
							...reqObj
						},
						{ headers: { "hub-id": hubId } }
					)
					toast("Updated Successfully")
					setFormData({
						text: "",
						name: "",
						templatename: "",
						status: "",
						module: "",
						mediatype: "",
						mediaURL: ""
					})
					onUpdateWhatsAppTemplate?.()
				})()
					.catch(console.err)
					.finally(() => setLoading(false))
			})
			.catch(setError)
	}

	const getTemplatePreview = ({ text }) => {
		try {
			return parseStringTemplate(text, templateVariablesFlat)
		} catch (err) {
			console.error(err)
			return formObj.text
		}
	}

	const onClickVariables = ({ key }) => {
		if (templateTextRef?.current) {
			const currPos = templateTextRef.current.selectionStart
			let existingValue = formObj.text || ""
			const newValue =
				existingValue.slice(0, currPos) +
				`{{${optionTypeData.status + "." + templateVariablesFlat[key]} || Default_Value }}` +
				// `{{${key}}}` +
				existingValue.slice(currPos)
			setFormData({ ...formObj, text: newValue })
		}
	}

	function onTypedSearch(event) {
		const value = event.target.value
		setSearchVariable(value)

		const result = Object.keys(templateVariablesFlatFiltered).map(
			(key) => templateVariablesFlatFiltered[key]
		)
		const filteredArray = value ? result.filter((item) => item.includes(value)) : result

		const flatData = flatten(filteredArray)
		setTemplateVariablesFlat(flatData)
	}
	function getExtension(filename) {
		var r = /.+\.(.+)$/.exec(filename)
		return r ? r[1] : null
	}

	const toBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = () => resolve(reader.result)
			reader.onerror = (error) => reject(error)
		})

	const uploadFile = (e) => {
		const file = e.target.files[0]
		if (!file) {
			return
		}

		const extenstion = getExtension(file.name)

		if (extenstion == null) {
			toast("Please upload a valid file")
			e.target.value = ""
			return
		}

		let fileType

		if (
			extenstion.toLowerCase() == "jpg" ||
			extenstion.toLowerCase() == "jpeg" ||
			extenstion.toLowerCase() == "png" ||
			extenstion.toLowerCase() == "gif"
		) {
			fileType = "image"
		} else if (extenstion.toLowerCase() == "pdf") {
			fileType = "document"
		}

		if (fileType == null) {
			toast(`Unsupported file type. Supported Formats: Image (jpg, jpeg, png, gif) &
			Document (pdf)`)
			e.target.value = ""
			return
		}

		if (fileType !== formObj.mediatype) {
			toast(`File type does not match the template type.`)
			e.target.value = ""
			return
		}

		setLoading(true)
		;(async () => {
			const base64 = await toBase64(file)

			const { data } = await axiosInstance.post(
				EndpointConfig.VFUpload,
				{
					file: base64,
					fileType,
					filename: `${Date.now()}.${extenstion}`
				},
				{
					headers: {
						"hub-id": hubId
					}
				}
			)

			if (data.url) {
				setFormData({ ...formObj, mediaURL: data.url })
				toast("File Uploaded successfully")
				e.target.value = ""
			}
		})()
			.catch((err) => {
				console.err(err)
				toast("Failed")
			})
			.finally(() => setLoading(false))
	}

	return (
		<>
			<div className="flex flex-col">
				<Header IconName={CogIcon} subText={"Setup"} mainText={"Update New Templates"} />
				<div className="flex flex-row gap-4">
					<div className="flex flex-col w-3/12 p-4 bg-white rounded">
						<Select
							placeholder={"Contact"}
							label="Contact"
							selectedValue={{
								label: optionTypeData.statusLabel,
								value: optionTypeData.status
							}}
							onSelect={({ label, value }) => {
								setOptionTypeData({ statusLabel: label, status: value })
								getTemplatePropertiesCallBack(value)
							}}
							options={optionsType}
						/>
						<Input
							name="name"
							error={error.name}
							onChange={onTypedSearch}
							value={searchVariable}
							label={"Search"}
							placeholder={"Search Variables"}
						/>
						<div className="mt-2 text-xs text-gray-500 uppercase">
							Available Variables
						</div>
						<div className="overflow-y-auto h-[350px] ">
							<>
								&nbsp;
								{loading && templateVariablesFlat ? (
									<div className="w-full p-1 text-sm text-center text-blue-900 pointer-events-none text-bold">
										Loading...
									</div>
								) : (
									Object.keys(templateVariablesFlat).map((key, index) => {
										return (
											<div
												key={key}
												className="flex flex-col py-2 text-xs border-t border-gray-100 border-solid"
												onClick={() => onClickVariables({ key })}
											>
												{/* <span className="flex-1 text-blue-800">
                          {templateVariablesFlat[key]}
                        </span> */}
												<span className="text-gray-800">
													{templateVariablesFlat[key]}
												</span>
											</div>
										)
									})
								)}
							</>
						</div>
					</div>
					<div className="flex flex-col flex-1 p-4 bg-white rounded">
						<Input
							name="name"
							error={error.name}
							onChange={(e) => setFormObj({ name: e.target.value })}
							value={formObj.name}
							label={"Name"}
							placeholder={"Record name"}
						/>
						<Input
							name="templatename"
							disabled={true}
							error={error.templatename}
							onChange={(e) => setFormObj({ templatename: e.target.value })}
							value={formObj.templatename}
							label={"Template Name"}
							placeholder={"Template name"}
						/>
						<Select
							placeholder={"Module"}
							error={error.module}
							label="Module"
							selectedValue={{ label: formObj.module, value: formObj.module }}
							// valueRendered={(selectedValue) => selectedValue.userId}
							onSelect={({ value }) => {
								setFormObj({ module: value })
							}}
							options={["Contact", "Deals", "Companies", "Ticket"].map((ob) => ({
								label: ob,
								value: ob
							}))}
						/>

						<div className="flex flex-row gap-4">
							<div className="flex flex-col flex-1">
								<TextArea
									label={`Template Text`}
									ref={templateTextRef}
									error={error.text}
									onChange={(e) => setFormObj({ text: e.target.value })}
									value={formObj.text}
									placeholder="Template Text"
								/>
							</div>
							<div className="flex flex-col flex-1">
								<label className="mt-2 text-xs text-gray-500 uppercase">
									Preview Text [Sample Data]
								</label>
								{formObj.text ? (
									<p className="text-sm ">
										{/* {getTemplatePreview({ text: formObj.text })} */}
										{formObj.text}
									</p>
								) : (
									"......."
								)}
							</div>
						</div>
						{formObj?.mediatype && (
							<>
								<div className="flex flex-row gap-4 my-1">
									<label class="form-label" id="mediaType">
										Media Type: {formObj?.mediatype}
									</label>
								</div>
								<div className="flex flex-row gap-4">
									<Input
										name="mediaURL"
										error={error.mediaURL}
										onChange={(e) => setFormObj({ mediaURL: e.target.value })}
										value={formObj.mediaURL}
										label={"Media URL"}
									/>

									{formObj?.mediatype !== "video" && (
										<Input name="name" type="file" onChange={uploadFile} />
									)}
								</div>
							</>
						)}

						{/* <div className="flex flex-row gap-4"> */}
						{/* <Input name='userId'
                                error={error.userId}
                                onChange={e => setFormObj({ userId: e.target.value })} value={formObj.userId}
                                label={'User ID'} placeholder={'User ID'}
                            /> */}
						{/* <Input name='senderId'
                                error={error.senderId}
                                onChange={e => setFormObj({ senderId: e.target.value })} value={formObj.senderId}
                                label={'Sender Id'} placeholder={'Sender Id'}
                            /> */}
						{/* </div> */}

						<div className="flex flex-row gap-6">
							<div className="flex-[3]">&nbsp;</div>
							<div className="flex-1">
								&nbsp;
								{loading ? (
									<Button className="w-full p-1 text-xs text-black bg-red-100 pointer-events-none">
										Loading
									</Button>
								) : (
									<Button className="w-full" onClick={updateTemplate}>
										Update Template
									</Button>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
